<div class="bg-gray-50 dark:bg-gray-800 rounded-3xl shadow-2xl border border-gray-200 dark:border-gray-700 overflow-hidden">
  @if (title) {
    <div class="bg-brand-600 dark:bg-brand-700 px-8 py-6">
      <div class="flex items-center gap-3">
        <div class="w-2 h-8 bg-white/30 rounded-full"></div>
        <h3 class="text-xl font-bold text-white tracking-tight">
          {{ title }}
        </h3>
      </div>
    </div>
  }
  
  <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
    <div class="bg-gray-50 dark:bg-gray-700 px-6 py-5 border-b border-gray-200 dark:border-gray-600">
      <ng-content select="[header]"></ng-content>
    </div>

    @if (dataPage && dataPage.data && dataPage.data.length > 0) {
      <div class="overflow-x-auto">
        <table class="w-full">
          <thead>
            <tr class="bg-gray-100 dark:bg-gray-700">
              @for (column of columns; track column) {
                <th [ngStyle]="{'width': column.width}" class="px-6 py-4 text-left">
                  <div class="flex items-center justify-between group">
                    <span class="text-sm font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                      {{ column.header }}
                    </span>
                    @if (column.sortable) {
                      <button
                        (click)="toggleSort(column)"
                        class="ml-2 p-1 rounded-lg text-gray-500 dark:text-gray-400 hover:text-brand-600 dark:hover:text-brand-400 hover:bg-brand-50 dark:hover:bg-brand-900/20 transition-all duration-200 opacity-0 group-hover:opacity-100"
                      >
                        <lucide-icon size="16" [name]="sortIcon(column)"></lucide-icon>
                      </button>
                    }
                  </div>
                </th>
              }
              @if (this.rowActions.length > 0) {
                <th class="px-6 py-4 text-center w-24">
                  <span class="text-sm font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider">
                    Actions
                  </span>
                </th>
              }
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200/50 dark:divide-gray-600/50">
            @for (item of dataPage.data; track item.id; let i = $index) {
              <tr
                (click)="rowRouterLinkTemplate ? handleRoute(item) : null"
                class="group transition-all duration-300 ease-out"
                [ngClass]="{
                  'cursor-pointer': rowRouterLinkTemplate,
                  'cursor-default': !rowRouterLinkTemplate,
                  'hover:bg-brand-50 dark:hover:bg-brand-900/20 hover:shadow-md hover:border-l-4 hover:border-l-brand-500': hover,
                  'bg-white dark:bg-gray-800': i % 2 === 0,
                  'bg-gray-50 dark:bg-gray-750': i % 2 === 1
                }"
              >
                @for (column of columns; track column) {
                  <td class="px-6 py-4"
                      [ngStyle]="{'cursor': column.clickHandler ? 'pointer' : 'default'}"
                  >
                      <div class="flex items-center">
                        @if (column.type === 'image') {
                          @if (item[column.field]) {
                            <div class="w-12 h-12 rounded-xl overflow-hidden border-2 border-white dark:border-gray-600 shadow-md">
                              <img class="w-full h-full object-cover" src="{{ item[column.field] }}" alt="{{ column.header }}">
                            </div>
                          }
                        } @else {
                          @if (column.component) {
                            <ng-container *ngComponentOutlet="column.component; inputs: {item: item}"></ng-container>
                          } @else {
                            @if (column.type === 'badge' && column.getColor) {
                              <app-badge [text]="getValue(item, column)" [color]="column.getColor(item)"></app-badge>
                            } @else {
                              @if (column.type === 'boolean') {
                                <app-badge [text]="getValue(item, column) ? 'Yes' : 'No'" [color]="getValue(item, column) ? 'success' : 'error'"></app-badge>
                              } @else {
                                @if (column.routerLinkTemplate) {
                                  <a [routerLink]="generateRouterLink(column.routerLinkTemplate, item)"
                                     class="text-brand-600 dark:text-brand-400 hover:text-brand-800 dark:hover:text-brand-300 font-medium hover:underline transition-colors duration-200">
                                    {{ getValue(item, column) }}
                                  </a>
                                } @else {
                                  @if (column.clickHandler) {
                                    <button (click)="column.clickHandler(item)"
                                            class="text-brand-600 dark:text-brand-400 hover:text-brand-800 dark:hover:text-brand-300 font-medium hover:underline transition-colors duration-200">
                                      {{ getValue(item, column) }}
                                    </button>
                                  } @else {
                                    <span class="text-gray-700 dark:text-gray-300 font-medium">
                                      {{ getValue(item, column) }}
                                    </span>
                                  }
                                }
                              }
                            }
                          }
                        }
                      </div>
                    </td>
                  }
                  @if (this.rowActions.length > 0) {
                    <td class="px-6 py-4">
                      <div class="flex justify-center items-center gap-2">
                        @for (action of rowActions; track action) {
                          @if (action.callback) {
                            <button
                              (click)="$event.stopPropagation(); action.callback(item)"
                              class="p-2 rounded-xl transition-all duration-200 hover:shadow-lg"
                              [ngClass]="action.classes ?? 'text-gray-500 hover:text-brand-600 hover:bg-brand-50 dark:text-gray-400 dark:hover:text-brand-400 dark:hover:bg-brand-900/20'"
                            >
                              <lucide-icon [size]="18" [name]="action.icon"></lucide-icon>
                            </button>
                          } @else if (action.routerLink) {
                            <button
                              (click)="$event.stopPropagation()"
                              [routerLink]="action.routerLink(item)"
                              class="p-2 rounded-xl transition-all duration-200 hover:shadow-lg"
                              [ngClass]="action.classes ?? 'text-gray-500 hover:text-brand-600 hover:bg-brand-50 dark:text-gray-400 dark:hover:text-brand-400 dark:hover:bg-brand-900/20'"
                            >
                              <lucide-icon [size]="18" [name]="action.icon"></lucide-icon>
                            </button>
                          }
                        }
                      </div>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      }

      @if (noDataPlaceholder && dataPage && dataPage.data && dataPage.data.length === 0) {
        <div class="flex flex-col items-center justify-center py-24 px-8">
          <div class="w-20 h-20 rounded-2xl bg-gray-100 dark:bg-gray-700 flex items-center justify-center shadow-lg">
            <lucide-icon [name]="FileX2Icon" size="40" class="text-gray-400 dark:text-gray-500"></lucide-icon>
          </div>
          <h3 class="mt-6 text-xl font-semibold text-gray-700 dark:text-gray-300">No Data Available</h3>
          <p class="mt-2 text-gray-500 dark:text-gray-400 text-center max-w-md">There's nothing to display here yet. Add some data to get started.</p>
        </div>
      }

      @if (loading) {
        <div class="flex flex-col items-center justify-center py-24 px-8">
          <div class="w-20 h-20 rounded-2xl bg-brand-100 dark:bg-brand-900/30 flex items-center justify-center shadow-lg animate-pulse">
            <lucide-icon [name]="LoaderIcon" size="40" class="text-brand-600 dark:text-brand-400 animate-spin"></lucide-icon>
          </div>
          <h3 class="mt-6 text-xl font-semibold text-gray-700 dark:text-gray-300">Loading...</h3>
          <p class="mt-2 text-gray-500 dark:text-gray-400">Please wait while we fetch your data.</p>
        </div>
      }

      @if (paginate && dataPage && dataPage.meta.last_page > 1) {
        <div class="bg-gray-50 dark:bg-gray-700 border-t border-gray-200 dark:border-gray-600 px-6 py-5">
          <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
            @if (paginate) {
              <div class="flex items-center gap-3">
                <span class="text-sm font-medium text-gray-600 dark:text-gray-400">Show</span>
                <div class="w-20">
                  <app-select [height]="'9'" [control]="showPerPageControl" [choices]="perPageChoices"></app-select>
                </div>
                <span class="text-sm font-medium text-gray-600 dark:text-gray-400">entries</span>
              </div>
            }

            <div class="flex items-center justify-center lg:justify-start">
              <div class="bg-white dark:bg-gray-800 rounded-xl px-4 py-2 border border-gray-200 dark:border-gray-600 shadow-sm">
                <p class="text-sm font-medium text-gray-700 dark:text-gray-300">
                  Showing <span class="text-brand-600 dark:text-brand-400 font-semibold">{{ startEntry }}</span> to
                  <span class="text-brand-600 dark:text-brand-400 font-semibold">{{ endEntry }}</span> of
                  <span class="text-brand-600 dark:text-brand-400 font-semibold">{{ totalEntries }}</span> entries
                </p>
              </div>
            </div>

            <div class="flex items-center justify-center gap-2">
              <button
                (click)="prevPage()"
                class="flex items-center gap-2 px-4 py-2 rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 font-medium transition-all duration-200 hover:bg-brand-50 hover:border-brand-300 hover:text-brand-700 dark:hover:bg-brand-900/20 dark:hover:border-brand-600 dark:hover:text-brand-400 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white dark:disabled:hover:bg-gray-800"
                [disabled]="currentPage === 1"
              >
                <lucide-icon name="chevron-left" size="16"></lucide-icon>
                Previous
              </button>

              <div class="flex items-center gap-1">
                <button
                  (click)="goToPage(1)"
                  class="w-10 h-10 rounded-xl text-sm font-semibold transition-all duration-200"
                  [ngClass]="currentPage === 1 ?
                    'bg-brand-500 text-white shadow-lg' :
                    'text-gray-600 dark:text-gray-400 hover:bg-brand-50 dark:hover:bg-brand-900/20 hover:text-brand-600 dark:hover:text-brand-400'"
                >
                  1
                </button>

                @if (currentPage > 3) {
                  <span class="w-10 h-10 flex items-center justify-center text-gray-400 dark:text-gray-500">...</span>
                }

                @for (page of pagesAroundCurrent; track page) {
                  <button
                    (click)="goToPage(page)"
                    class="w-10 h-10 rounded-xl text-sm font-semibold transition-all duration-200"
                    [ngClass]="currentPage === page ?
                      'bg-brand-500 text-white shadow-lg' :
                      'text-gray-600 dark:text-gray-400 hover:bg-brand-50 dark:hover:bg-brand-900/20 hover:text-brand-600 dark:hover:text-brand-400'"
                  >
                    {{ page }}
                  </button>
                }

                @if (currentPage < totalPages - 2) {
                  <span class="w-10 h-10 flex items-center justify-center text-gray-400 dark:text-gray-500">...</span>
                }
              </div>

              <button
                (click)="nextPage()"
                class="flex items-center gap-2 px-4 py-2 rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 font-medium transition-all duration-200 hover:bg-brand-50 hover:border-brand-300 hover:text-brand-700 dark:hover:bg-brand-900/20 dark:hover:border-brand-600 dark:hover:text-brand-400 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white dark:disabled:hover:bg-gray-800"
                [disabled]="currentPage === totalPages"
              >
                Next
                <lucide-icon name="chevron-right" size="16"></lucide-icon>
              </button>
            </div>
          </div>
        </div>
      }

    <div class="bg-gray-50 dark:bg-gray-700 border-t border-gray-200 dark:border-gray-600 px-6 py-4">
      <ng-content select="[footer]"></ng-content>
    </div>
  </div>
</div>
